module.exports = __webpack_public_path__ + "static/img/pan.67f2179e.webp";